import { render, staticRenderFns } from "./BlackMicropointV2.vue?vue&type=template&id=783a2a25&scoped=true"
import script from "./BlackMicropointV2.vue?vue&type=script&lang=js"
export * from "./BlackMicropointV2.vue?vue&type=script&lang=js"
import style0 from "./BlackMicropointV2.vue?vue&type=style&index=0&id=783a2a25&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "783a2a25",
  null
  
)

export default component.exports